import $ from 'jquery';

const $header = $('.header');
const $headerInner = $('.header__inner');
const $hamburger = $('.c-hamburger');
const $nav = $('.nav');
const $headerInnerSub = $('.header__inner--sub');
const $logo = $('.c-logo');
const $logoImage = $('.c-logo__image');
const $logoImageMain = $('.c-logo__image-main');
const $logoLabel = $('.c-logo__label');
const $submenu = $('.nav__submenu-outer');

function addScrollClasses() {
  $header.addClass('header--scrolled');
  $logo.addClass('c-logo--scrolled');
  $hamburger.addClass('c-hamburger--scrolled');
  $nav.addClass('nav--scrolled');
  $headerInnerSub.addClass('header__inner--sub--scrolled');
  $headerInner.addClass('header__inner--scrolled');
  $logoImage.addClass('c-logo__image--scrolled');
  $logoImageMain.addClass('c-logo__image--scrolled-main').removeClass('c-logo__image--scrolled');
  $logoLabel.addClass('c-logo__label--scrolled');
  $submenu.addClass('nav__submenu-outer--scrolled');
}

$(window).bind('scroll', () => {
  const scrollTop = $(window).scrollTop();
  const elementOffset = $('body').offset().top;
  const distance = (elementOffset - scrollTop);
  const headerHeight = 0;

  if (distance < headerHeight) {
    if (!$header.hasClass('header--scrolled')) {
      addScrollClasses();
    }
  }
  if (distance >= headerHeight) {
    $header.removeClass('header--scrolled');
    $logo.removeClass('c-logo--scrolled');
    $hamburger.removeClass('c-hamburger--scrolled');
    $nav.removeClass('nav--scrolled');
    $headerInner.removeClass('header__inner--scrolled');
    $headerInnerSub.removeClass('header__inner--sub--scrolled');
    $logoImage.removeClass('c-logo__image--scrolled');
    $logoImageMain.removeClass('c-logo__image--scrolled-main');
    $logoLabel.removeClass('c-logo__label--scrolled');
    $submenu.removeClass('nav__submenu-outer--scrolled');
  }
});
